<div class="navbar-area border-b relative z-10 py-[20px] lg:py-[25px] xl:py-0"
    [ngClass]="[navbarClass, isSticky ? 'isSticky' : '']">
    <div class="mx-auto px-[12px] sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1920px] 2xl:px-[30px] 3xl:px-[120px]">
        <nav class="navbar relative flex flex-wrap" [class.active]="classApplied">

            <!-- LOGO SECTION -->
            <div class="self-center">
                <a routerLink="/" [ngClass]="{'hidden': router.url === '/index-3'}">
                    <!-- 🔥 AQUÍ ESTÁ EL CAMBIO: Solo cambiar esta línea -->
                    <img [src]="(isAuthenticated$ | async) ? 'assets/images/logogobant.png' : logoGov"
                        class="inline w-auto h-[6vh] sm:h-[10vh] xl:h-[8vh] 3xl:h-[130px] 3xl:py-[15px]"
                        alt="logo">
                </a>
            </div>

            <!-- MOBILE MENU BUTTON -->
            <button class="navbar-toggler absolute ml-auto right-0 top-[4px] xl:hidden"
                    type="button"
                    (click)="toggleClass()">
                <span class="burger-menu text-black cursor-pointer leading-none text-[30px]"
                      [ngClass]="{'text-white': router.url === '/index-3'}">
                    <i class="ri-menu-line"></i>
                </span>
            </button>

            <!-- NAVBAR CONTENT -->
            <div class="navbar-collapse flex self-center grow basis-auto"
                 [ngClass]="[navbarClass, isSticky ? 'isSticky' : '']">

                <!-- DESKTOP MENU -->
                <ul class="navbar-nav self-center flex-row ml-auto hidden xl:flex">
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0"
                        [ngClass]="{'2xl:py-[32px]': router.url === '/'}">
                        <a [routerLink]="['/inicio']"
                           fragment="bannerSection"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-CyanBlue"
                           [ngClass]="{
                                'text-white hover:text-Teal': isAuthenticated$ | async,
                                'text-black hover:text-CyanBlue': !(isAuthenticated$ | async),
                                'text-sec_amarillo': activeSection === 'bannerSection' && (isAuthenticated$ | async),
                                'text-Teal': activeSection === 'bannerSection' && !(isAuthenticated$ | async)
                            }">
                            {{ texts?.home }}
                        </a>
                    </li>
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0"
                        [ngClass]="{'2xl:py-[32px]': router.url === '/'}">
                        <a [routerLink]="['/inicio']"
                           fragment="featureSection"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-CyanBlue"
                           [ngClass]="{
                                'text-white hover:text-Teal': isAuthenticated$ | async,
                                'text-black hover:text-CyanBlue': !(isAuthenticated$ | async),
                                'text-sec_amarillo': activeSection === 'featureSection' && (isAuthenticated$ | async),
                                'text-Teal': activeSection === 'featureSection' && !(isAuthenticated$ | async)
                            }">
                            {{ texts?.PQRS }}
                        </a>
                    </li>
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0"
                        [ngClass]="{'2xl:py-[32px]': router.url === '/'}">
                        <a [routerLink]="['/inicio']"
                           fragment="cardsSection"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-CyanBlue"
                           [ngClass]="{
                                'text-white hover:text-Teal': isAuthenticated$ | async,
                                'text-black hover:text-CyanBlue': !(isAuthenticated$ | async),
                                'text-sec_amarillo': activeSection === 'cardsSection' && (isAuthenticated$ | async),
                                'text-Teal': activeSection === 'cardsSection' && !(isAuthenticated$ | async)
                            }">
                            {{ texts?.contact }}
                        </a>
                    </li>
                </ul>

                <!-- MOBILE MENU -->
                <ul class="navbar-nav xl:hidden">
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0"
                        [ngClass]="{'2xl:py-[32px]': router.url === '/'}">
                        <a [routerLink]="['/inicio']"
                           fragment="bannerSection"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-CyanBlue"
                           [ngClass]="{
                                'text-white hover:text-Teal': isAuthenticated$ | async,
                                'text-black hover:text-CyanBlue': !(isAuthenticated$ | async),
                                'text-sec_amarillo': activeSection === 'bannerSection' && (isAuthenticated$ | async),
                                'text-Teal': activeSection === 'bannerSection' && !(isAuthenticated$ | async)
                            }">
                            {{ texts?.home }}
                        </a>
                    </li>
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0"
                        [ngClass]="{'2xl:py-[32px]': router.url === '/'}">
                        <a [routerLink]="['/inicio']"
                           fragment="featureSection"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-CyanBlue"
                           [ngClass]="{
                                'text-white hover:text-Teal': isAuthenticated$ | async,
                                'text-black hover:text-CyanBlue': !(isAuthenticated$ | async),
                                'text-sec_amarillo': activeSection === 'featureSection' && (isAuthenticated$ | async),
                                'text-Teal': activeSection === 'featureSection' && !(isAuthenticated$ | async)
                            }">
                            {{ texts?.PQRS }}
                        </a>
                    </li>
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0"
                        [ngClass]="{'2xl:py-[32px]': router.url === '/'}">
                        <a [routerLink]="['/inicio']"
                           fragment="cardsSection"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-CyanBlue"
                           [ngClass]="{
                                'text-white hover:text-Teal': isAuthenticated$ | async,
                                'text-black hover:text-CyanBlue': !(isAuthenticated$ | async),
                                'text-sec_amarillo': activeSection === 'cardsSection' && (isAuthenticated$ | async),
                                'text-Teal': activeSection === 'cardsSection' && !(isAuthenticated$ | async)
                            }">
                            {{ texts?.contact }}
                        </a>
                    </li>
                </ul>

                <!-- USER OPTIONS -->
                <!-- <div class="other-options self-center flex flex-col sm:flex-row items-start border-t border-[#eeeeee] xl:border-none xl:ml-[20px] 2xl:ml-[50px] md:pt-[15px] lg:pt-[20px] xl:pt-0 mb-[10px] xl:mb-0"
                     [ngClass]="{'border-[#413e3e]': router.url === '/index-3'}">

                    <!-- PERFIL USUARIO BUTTON
                    <a [href]="url_perfilUsuario"
                       target="_blank"
                       class="mr-[0px] sm:mr-[15px] 2xl:mr-[20px] mt-[15px] md:mt-0 mb-[15px] md:mb-0 py-[11px] md:py-[12px] lg:py-[12.5px] px-[7px] md:px-[15px] inline-block text-[13px] md:text-[14px] 3xl:text-[20px] font-medium uppercase rounded-lg transition-all border border-transparent hover:text-white hover:bg-Teal hover:border-Teal focus:border-Teal"
                       (click)="toggleClass()">
                        {{ texts?.perfil_usuario }}
                    </a>

                    <!-- NOT AUTHENTICATED OPTIONS
                    <ng-container *ngIf="!(isAuthenticated$ | async)">
                        <a routerLink="/inicio"
                           class="mr-[0px] sm:mr-[15px] 2xl:mr-[20px] mt-[15px] md:mt-0 py-[11px] md:py-[12px] lg:py-[12.5px] px-[30px] md:px-[40px] inline-block text-[#ffffff] text-[13px] md:text-[14px] 3xl:text-[20px] font-medium uppercase border border-Navy bg-Navy rounded-full transition-all hover:bg-transparent hover:text-Navy"
                           [ngClass]="{'text-white border-white hover:border-[#0a64bc]': router.url === '/index-3'}"
                           (click)="toggleClass()">
                            {{ texts?.login }}
                        </a><!-- /iniciar-sesion
                        <a routerLink="/inicio"
                           class="mr-[0px] sm:mr-[15px] 2xl:mr-[20px] mt-[15px] md:mt-0 py-[11px] md:py-[12px] lg:py-[12.5px] px-[30px] md:px-[40px] inline-block text-Navy text-[13px] md:text-[14px] 3xl:text-[20px] font-medium uppercase border border-Navy bg-transparent rounded-full transition-all hover:bg-Navy hover:text-[#ffffff]"
                           (click)="toggleClass()">
                            {{ texts?.register }}
                        </a><!-- /registrarse
                    </ng-container>

                    <!-- AUTHENTICATED USER OPTIONS
                    <ng-container *ngIf="isAuthenticated$ | async">
                        <div class="inline-block ml-[15px] 2xl:ml-[20px]">
                            <div class="relative z-40" #dropdownMenu>
                                <button (click)="toggleDropdown()"
                                        class="block h-12 w-12 rounded-full overflow-hidden focus:outline-none">
                                    <img class="h-full w-full object-cover"
                                         [src]="imgUserName"
                                         alt="avatar">
                                </button>

                                <!-- USER DROPDOWN
                                <div *ngIf="isDropdownOpen"
     class="absolute top-full right-0 w-40 mt-2 py-2 bg-white border rounded shadow-xl z-50 xl:right-0 2xl:right-0 3xl:right-0">
                                    <a class="transition-colors duration-200 block px-4 py-2 text-normal text-gray-900 font-bold rounded">
                                        {{(currentUser?.nombres || '').split(' ')[0]}} {{(currentUser?.apellidos || '').split(' ')[0]}}
                                    </a>
                                    <div class="py-2">
                                        <hr>
                                    </div>
                                    <div class="flex justify-center items-center">
                                        <button (click)="logout()"
                                                class="transition-colors duration-200 block px-4 py-2 text-normal text-gray-900 rounded hover:bg-CyanBlue/90 hover:text-white">
                                            Cerrar Sesión
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div> -->
            </div>
        </nav>
    </div>
</div>
